var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBreachRiskAttestations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1313.002 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.552,135,33.5,33H72.8l22.95,102h-20.7L71,116.55H35.3L31.252,135Zm39-84.9L39.2,98.55H67.1L56.752,50.1Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.666,76.41V63.6h52.5V76.41h-18.9V135h-14.49V76.41Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.794,76.41V63.6h52.5V76.41h-18.9V135H168.9V76.41Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.328,135V63.6h46.2V76.2H223.817V92.9h25.411v12.389H223.817V122.4h31.711V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.341,74.94q-11.447,0-11.445,7.56a5.726,5.726,0,0,0,2.835,5.146q2.835,1.785,13.283,5.144t14.647,7.612q4.2,4.252,4.2,13.074,0,11.237-6.825,17.009t-17.85,5.775a99.33,99.33,0,0,1-20.055-2.52l-3.78-.735,1.47-11.234a174.928,174.928,0,0,0,21.525,1.889q11.128,0,11.13-9.24a6.151,6.151,0,0,0-2.573-5.25q-2.573-1.89-10.237-4.095-12.181-3.463-17.167-8.242T261.511,83.55q0-10.71,6.51-15.96t17.85-5.25a118.717,118.717,0,0,1,19.74,2.1l3.78.735L308.236,76.62Q293.431,74.942,287.341,74.94Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.01,76.41V63.6h52.5V76.41h-18.9V135H333.12V76.41Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.675,135,379.74,63.6h27.51L423.314,135H408.825l-2.835-12.915H381L378.165,135Zm27.3-59.43-7.246,33.915H403.26L396.015,75.57Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.48,76.41V63.6h52.5V76.41h-18.9V135H439.59V76.41Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.014,135V63.6H494.5V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.346,127.388q-6.669,8.874-22.943,8.872t-22.942-8.872q-6.669-8.871-6.668-27.773t6.668-28.088q6.666-9.186,22.942-9.187t22.943,9.187q6.668,9.191,6.667,28.088T557.346,127.388ZM522.8,118.147q3.1,5.513,11.6,5.513t11.6-5.513q3.1-5.511,3.1-18.479T545.953,80.82q-3.148-5.88-11.55-5.88t-11.549,5.88Q519.7,86.7,519.7,99.668T522.8,118.147Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.3,135V63.6h24.465l17.22,58.8h1.05V63.6h14.49V135H607.692l-17.85-58.8h-1.05V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.912,74.94q-11.447,0-11.445,7.56a5.726,5.726,0,0,0,2.835,5.146q2.835,1.785,13.282,5.144t14.648,7.612q4.2,4.252,4.2,13.074,0,11.237-6.825,17.009t-17.85,5.775a99.321,99.321,0,0,1-20.055-2.52l-3.78-.735,1.47-11.234a174.928,174.928,0,0,0,21.525,1.889q11.127,0,11.13-9.24a6.151,6.151,0,0,0-2.573-5.25q-2.574-1.89-10.237-4.095-12.182-3.463-17.168-8.242T641.082,83.55q0-10.71,6.51-15.96t17.85-5.25a118.717,118.717,0,0,1,19.74,2.1l3.78.735L687.807,76.62Q673,74.942,666.912,74.94Z",
    style: {
      fill: "#5e1513"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreachRiskAttestations);
export default __webpack_public_path__ + "static/media/BreachRisk_Attestations.55b275672730580f1eedc3d26cbb0468.svg";
export { ForwardRef as ReactComponent };